import { CHAVES_SLOT_HOME, ehBlocoTexto } from "./blocoConteudo";

export const LOCAIS_CONTEUDO = {
  pre_menu: {
    label: "Pré-menu",
    description: "Topo da página inicial, abaixo da faixa institucional",
    icon: "cil-bullhorn",
  },
  pre_vitrine: {
    label: "Pré-vitrine",
    description: "Antes da primeira vitrine de produtos",
    icon: "cil-star",
  },
  entre_vitrine: {
    label: "Entre vitrines",
    description: "Entre duas vitrines de produtos",
    icon: "cil-columns",
  },
  pos_vitrine: {
    label: "Pós-vitrine",
    description: "Depois da última vitrine de produtos",
    icon: "cil-list-low-priority",
  },
  pre_rodape: {
    label: "Pré-rodapé",
    description: "Acima do rodapé, para marcas e parceiros",
    icon: "cil-library",
  },
  pre_menu_lateral: {
    label: "Pré-menu lateral",
    description: "Acima do menu lateral de categorias",
    icon: "cil-list",
  },
  rodape: {
    label: "Rodapé",
    description: "Logotipo exibido no rodapé",
    icon: "cil-building",
  },
  pagamento: {
    label: "Pagamento",
    description: "Bandeiras e formas de pagamento",
    icon: "cil-credit-card",
  },
  certificado: {
    label: "Certificado",
    description: "Selos de certificação do site",
    icon: "cil-badge",
  },
  seguranca: {
    label: "Segurança",
    description: "Selo de segurança, em imagem ou HTML",
    icon: "cil-shield-alt",
  },
  aplicativo: {
    label: "Aplicativo",
    description: "Links para baixar o aplicativo",
    icon: "cil-mobile",
  },
};

export const TIPOS_CONTEUDO = {
  imagem: {
    label: "Imagem",
    description: "Arte pronta com link de destino",
    icon: "cil-image-plus",
  },
  texto: {
    label: "Bloco de texto",
    description: "Título, texto e botão, sem depender de arte",
    icon: "cil-notes",
  },
};

export const LARGURAS = [
  { valor: 12, percentual: "100%", texto: "100% (1 por linha)", desktop: "1140 x 220" },
  { valor: 8, percentual: "66%", texto: "66% (2/3 da linha)", desktop: "750 x 220" },
  { valor: 6, percentual: "50%", texto: "50% (2 por linha)", desktop: "560 x 220" },
  { valor: 4, percentual: "33%", texto: "33% (3 por linha)", desktop: "370 x 220" },
  { valor: 3, percentual: "25%", texto: "25% (4 por linha)", desktop: "270 x 220" },
  { valor: 2, percentual: "16%", texto: "16% (6 por linha)", desktop: "180 x 220" },
];

export const CANAIS = [
  { campo: "acesso_site", label: "VersoCommerce", sigla: "Site" },
  { campo: "acesso_app", label: "VersoApp", sigla: "App" },
  { campo: "acesso_cliente_final", label: "VersoApp - Cliente Final", sigla: "Cliente final" },
];

export const STATUS_CONTEUDO = {
  ATIVO: { label: "Ativo", badgeColor: "#5eb95e" },
  INATIVO: { label: "Inativo", badgeColor: "#666" },
};

const ehVerdadeiro = (valor) => valor === true || Number(valor) === 1;

export function corEscura(cor) {
  if (!cor || !/^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(cor)) {
    return false;
  }

  const hex =
    cor.length === 4
      ? cor
          .slice(1)
          .split("")
          .map((caractere) => caractere + caractere)
          .join("")
      : cor.slice(1);

  const vermelho = parseInt(hex.slice(0, 2), 16);
  const verde = parseInt(hex.slice(2, 4), 16);
  const azul = parseInt(hex.slice(4, 6), 16);

  return 0.299 * vermelho + 0.587 * verde + 0.114 * azul < 140;
}

export function getLocalConteudo(chave, logosTipo = []) {
  if (LOCAIS_CONTEUDO[chave]) {
    return { chave, ...LOCAIS_CONTEUDO[chave] };
  }

  const tipo = logosTipo.find((logoTipo) => logoTipo.chave === chave);

  return { chave, label: tipo ? tipo.tipo : chave || "—", description: "", icon: "cil-layers" };
}

export function locaisOrdenados(logosTipo = []) {
  const chaves = logosTipo.map((logoTipo) => logoTipo.chave);
  const primeiro = CHAVES_SLOT_HOME.filter((chave) => chaves.includes(chave));
  const depois = chaves.filter((chave) => !CHAVES_SLOT_HOME.includes(chave));

  return [...primeiro, ...depois].map((chave) => {
    const tipo = logosTipo.find((logoTipo) => logoTipo.chave === chave);

    return { ...getLocalConteudo(chave, logosTipo), id: tipo.id };
  });
}

export function chaveDoItem(item = {}, logosTipo = []) {
  if (item.chave) {
    return item.chave;
  }

  if (typeof item.tipo === "string") {
    return item.tipo;
  }

  const tipo = logosTipo.find((logoTipo) => logoTipo.id === item.tipo_id);

  return tipo ? tipo.chave : null;
}

export function getTipoConteudo(item = {}) {
  if (item.conteudo_tipo === "HTML") {
    return { chave: "HTML", label: "HTML", icon: "cil-code" };
  }

  if (ehBlocoTexto(item)) {
    return { chave: "texto", ...TIPOS_CONTEUDO.texto };
  }

  return { chave: "imagem", ...TIPOS_CONTEUDO.imagem };
}

export function getLarguraPercentual(valor) {
  const largura = LARGURAS.find((opcao) => opcao.valor === Number(valor));

  return largura ? largura.percentual : "—";
}

export function canaisDoConteudo(item = {}) {
  return CANAIS.filter((canal) => ehVerdadeiro(item[canal.campo]));
}

export function statusDoConteudo(item = {}) {
  return ehVerdadeiro(item.ativo) ? STATUS_CONTEUDO.ATIVO : STATUS_CONTEUDO.INATIVO;
}

export function contarPorLocal(itens = [], logosTipo = []) {
  return itens.reduce((contagem, item) => {
    const chave = chaveDoItem(item, logosTipo);
    contagem[chave] = (contagem[chave] || 0) + 1;

    return contagem;
  }, {});
}

export function filtrarConteudos(itens = [], filtros = {}, logosTipo = []) {
  const termo = (filtros.termo || "").trim().toLowerCase();
  const ordemDosLocais = [
    ...CHAVES_SLOT_HOME,
    ...locaisOrdenados(logosTipo)
      .map((local) => local.chave)
      .filter((chave) => !CHAVES_SLOT_HOME.includes(chave)),
  ];
  const ordemLocal = (item) => {
    const indice = ordemDosLocais.indexOf(chaveDoItem(item, logosTipo));

    return indice === -1 ? ordemDosLocais.length : indice;
  };

  return itens
    .filter((item) => {
      const chave = chaveDoItem(item, logosTipo);
      const tipoConteudo = getTipoConteudo({ ...item, chave }).chave;
      const textoBusca = [item.descricao, item.titulo, item.subtitulo, item.link]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();

      if (termo && !textoBusca.includes(termo)) {
        return false;
      }

      if (filtros.local && chave !== filtros.local) {
        return false;
      }

      if (filtros.conteudo && tipoConteudo !== filtros.conteudo) {
        return false;
      }

      if (filtros.status === "ATIVO" && !ehVerdadeiro(item.ativo)) {
        return false;
      }

      if (filtros.status === "INATIVO" && ehVerdadeiro(item.ativo)) {
        return false;
      }

      if (filtros.canal && !ehVerdadeiro(item[filtros.canal])) {
        return false;
      }

      return true;
    })
    .sort((a, b) => ordemLocal(a) - ordemLocal(b) || Number(a.ordem) - Number(b.ordem) || a.id - b.id);
}

export function tamanhoRecomendado(item = {}) {
  const largura = LARGURAS.find((opcao) => opcao.valor === Number(item.largura)) || LARGURAS[0];
  const mobileInteiro = !item.largura_mobile || Number(item.largura_mobile) === 12;

  return {
    percentual: largura.percentual,
    desktop: `${largura.desktop} px`,
    mobile: mobileInteiro ? "320 x 130 px" : "160 x 130 px",
  };
}

export function cloneParaCriacao(item = {}) {
  const copia = JSON.parse(JSON.stringify(item));

  return { ...copia, id: null, descricao: `Cópia de ${item.descricao || ""}`.trim() };
}
